import React, { useEffect } from "react";
import { Form, Input, Button, Typography, Row, Col, Space, message, Card, Switch } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, ContainerOutlined, LockOutlined, MailOutlined, PhoneOutlined, PlusCircleOutlined, UserOutlined } from "@ant-design/icons";
import api from "../../API";

function SubUser() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

const handleSubmit = async (values) => {
  try {
      const subUser = {
        ...values,
        parentId: user?.userId
      }
      const response = await api.create_new_user(subUser);
      message.success(response.message);
      navigate('/subusers', { replace: true });
  } catch (error) {
      message.error(error.message)
  }
};

return (
  <Card 
      style={{ maxWidth: 800, margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
      title= {
      <Space align="center">
          <Link to="/subusers">
              <Button style={{width: 50}} icon={<ArrowLeftOutlined />} />
          </Link>
          <Typography.Title level={5} style={{margin: 0}}>
            Create New User
          </Typography.Title>
      </Space>
  }>
      <Form 
          form={form} 
          layout="vertical" 
          onFinish={handleSubmit}
          initialValues={{ isActive: 0 }}
      >
          <Row gutter={[16, 0]}>
              <Col span={24}>
                  <Form.Item label="User name" name="username" rules={[{ required: true, message: "User Name cannot be empty" }]}>
                    <Input prefix={<UserOutlined/>} placeholder="Input your user name"/>
                  </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                  <Form.Item label="Password"  name="password" rules={[ { required: true, message: "Please input your Password!", }, {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/, message:'Minimum 8 characters (A->Z, a->z, 0->9, !@#...)'}]}>
                    <Input.Password prefix={<LockOutlined/>} placeholder="Password" allowClear/>
                  </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Phone" name='phone' rules={[{required: true, message: 'Please input your phone'}, {pattern: /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/, message: 'Phone number is incorrect'}]}>
                  <Input prefix={<PhoneOutlined />} maxLength={10} placeholder='Phone'/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Email" name='email' rules={[{required: true, message: 'Please input your email'}, {type: 'email', message:'Email is incorrect'}]}>
                  <Input prefix={<MailOutlined />} placeholder='Email'/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Tax Code" name='TaxCode' rules={[{required: true, message: 'Please input your tax code'}]}>
                  <Input prefix={<ContainerOutlined />} placeholder='Tax code'/>
                </Form.Item>
              </Col>
              
              <Col span={24}>
                <Form.Item  name='isActive' valuePropName="checked">
                  <Switch checkedChildren="Active" unCheckedChildren="Inactive"/>
                </Form.Item>
              </Col>
          </Row>

          <Form.Item style={{ textAlign: "center" }}>
              <Button type="primary" htmlType="submit" icon={<PlusCircleOutlined/>}>
                Save
              </Button>
          </Form.Item>
      </Form>
  </Card>
)}

export default SubUser;
